const cnfsd_evcm = (function () {

	const desktop = window.matchMedia("(min-width: 769px)"),
		domain = window.location.hostname,
		jsonDataFetchUrl = `https://${domain}/static/cmsmedia/cms-widgets/redesign/ev-charging-map/api`,
		mapForm = document.querySelector(".ev-map__form"),
		chargerDetailsDrawer = document.querySelector(".ev-map__details-drawer"),
		chargerDetailsContainer = document.querySelector(".ev-map__charger-details"),
		addressInputLabel = document.querySelector('label[for="evMapPostcode"]'),
		addressInput = document.getElementById("evMapPostcode"),
		loadingOverlay = document.querySelector(".ev-map__loading"),
		connectionTypes = document.getElementById("evMapConnectionType"),
		searchHere = document.querySelector(".ev-map__search-here"),
		searchHereButton = searchHere.querySelector("#searchHereButton"),
		AutoCompleteOptions = {
			fields: [ "formatted_address", "geometry", "name"  ],
			componentRestrictions: { country: "uk" },
			strictBounds: false,
			types: [ "locality", "sublocality" ],
		},
		autocomplete = new google.maps.places.Autocomplete(addressInput, AutoCompleteOptions),
		mediaQuery = window.matchMedia('(min-width: 768px)');


	let geocoder,
		geoLocation,
		geoLat,
		geoLong,
		markersArray = [],
		latlng,
		selectedPostCodeValue,
		connections,
		chargePointJsonData,
		filteredData,
		isChecked,
		previousGeoLocation = { lat: "", lng: "" },
		geoLocationSet = false,
		geoLocationError = false,
		selectedConnectionType,
		oldArray;

	function init() {
		geocoder = new google.maps.Geocoder();
		getGeoLocation();
		setupEventListeners();
	}


	// SET UP EVENT LISTENERS FOR CLICK & CHANGE FUNCTIONS ON EXISTING HTML ELEMENTS
	const setupEventListeners = () => {
		const getResultsButton = document.getElementById("getResults"),
			getGeoLocationButton = document.getElementById("useGeoLocation"),
			detailsDrawerCloseButton = document.querySelector(".ev-map__details-close");
			
		

		addressInput.addEventListener(
			"keypress",
			event => {
				if (event.defaultPrevented) {
					return; // Should do nothing if the default action has been cancelled
				}

				let handled = false,
					autoCompleteContainer = document.querySelector(".pac-container"),
					mapContainer = document.querySelector(".ev-map__map-container");
				
				if (event.key !== undefined) {
					if (event.key != "Enter") {
						return;
					} else {
						event.preventDefault();
						
						errorValidation(geoLocationError);
						if (!geoLocationError) {
							autoCompleteContainer.style.display = "none";
							mapContainer.focus();
							getChargerLocationData();
						}
					}
					handled = true;
				} else if (event.keyCode !== undefined) {
					if (event.keyCode === 13) {
						event.preventDefault();
						errorValidation(geoLocationError);
						if (!geoLocationError) {
							autoCompleteContainer.style.display = "none";
							mapContainer.focus();
							getChargerLocationData();
						}
					}
					handled = true;
				}

				if (handled) {
					// Suppress "double action" if event handled
					event.preventDefault();
				}
			},
			true
		);


		addressInput.addEventListener("focusin", () => {
			addressInput.value = "";
			geoLocationSet = false;
			addressInputLabel.innerHTML = "Enter postcode, town or city";
		});

		addressInput.addEventListener("change", () => {
			geoLocationSet = false;
		});

		getResultsButton.addEventListener("click", event => {
			event.preventDefault();
			geoLocationError = false;
			errorValidation(geoLocationError);
			if (!geoLocationError) {
				getChargerLocationData();
			}
		});

		getGeoLocationButton.addEventListener("click", event => {
			event.preventDefault();
			getGeoLocation(event);
		});

		detailsDrawerCloseButton.addEventListener("click", event => {
			event.preventDefault();
			detailsDrawerCloseToggle();
		});

		searchHereButton.addEventListener("click", event => {
			event.preventDefault();
			chargerDetailsDrawer.classList.remove("ev-map__details-drawer--open");


			let newLocation = map.getCenter();
			newLat = newLocation.lat();
			newLng = newLocation.lng();

			geoLocation = { lat: newLat, lng: newLng };
			(async () => {
				await getPostcodeFromGeoLocation(geoLocation);
				//console.log(addressInput.value);
				getChargerLocationData();
			})();
		});

		google.maps.event.addListener(autocomplete, 'place_changed', function() {
			const place = autocomplete.getPlace();		
			errorValidation(geoLocationError);
			getChargerLocationData();
			if (!place.geometry) {
				return
			} else {
				if (place.geometry.viewport) {
					map.fitBounds(place.geometry.viewport);
				} else {
					map.setCenter(place.geometry.location);
					map.setZoom(17);
				}
			}
		});


		connectionTypes.addEventListener('change', () => { 
			parseFetchedData(chargePointJsonData);
		})

	};

	const errorValidation = (geoLocationError) => { 

		let container = document.querySelector('.ev-map'),
			fieldGroup = addressInput.closest(".field-group");
		
		if (addressInput.value === "" || geoLocationError === true) {
			fieldGroup.classList.add("field-group--error");
			container.classList.add("error-height-adjust");
		} else {
			fieldGroup.classList.remove("field-group--error");
			container.classList.remove("error-height-adjust");
		}
	}

	async function getChargerLocationData() {
		geoLocationError = false;
		selectedPostCodeValue = addressInput.value;

		if (geoLocation != "" && geoLocationSet) {
			const geo = geoLocation;
			initMap(geo);
			getJSONData(geo);
		} else if (selectedPostCodeValue != "") {
			const geo = await geoCodePostcode(selectedPostCodeValue);
			if (!geoLocationError) {
				initMap(geo);
				getJSONData(geo);
			}
		}
	}

	

	const getGeoLocation = event => {
		
		event ? event.preventDefault() : null;
		resetValues();
		const options = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0,
		};
		// CALL TO BROWSER LOCATION API TO GET USER GEO LOCATION
		navigator.geolocation.getCurrentPosition(getLocationSuccess, getLocationError, options);
	}

	const resetValues = () => {
		geoLocation = "";
		geoLat = "";
		geoLong = "";
		selectedPostCodeValue = "";
	}


	// IF SUCCESSFUL RETRIEVAL OF USER LOCATION FROM BROWSER API
	async function getLocationSuccess(pos) {
		geoLocationError = false;
		const crd = pos.coords;
		geoLocation = { lat: crd.latitude, lng: crd.longitude };
		geoLat = crd.latitude;
		geoLong = crd.longitude;
		initMap(geoLocation);
		await getPostcodeFromGeoLocation(geoLocation);
		
		getChargerLocationData();

	};

	// HANDLE ERROR FOR UNSUCCESSFUL RETRIEVAL OF USER LOCATION FROM BROWSER API
	const getLocationError = err => {
		console.warn(`ERROR(${err.code}): ${err.message}`);
		if (err.code === 1) {
			geoLocation = { lat: 54.038812, lng: -1.906225 };
			initMap(geoLocation, zoomLevel = 6, locationKnown = false);
		} else {
			errorValidation(geoLocationError = true);
		}
	};

	// IF WE ARE LOCATING BY GEO LOCATION WE NEED TO CONVERT IN TO POST CODE TO SEACH THE API
	async function getPostcodeFromGeoLocation(geoLocation) { 
		geoLocationSet = false;
		try {
			let response = await geocoder.geocode({ location: geoLocation });
			if (response.results[ 0 ]) {

				response.results[ 0 ].address_components.forEach(function (part, i) {
					if (part.types[0] === "postal_code") {
						addressInput.value = part.short_name;
						selectedPostCodeValue = part.short_name;
					}
				})

				addressInputLabel.innerHTML = "Current Location";

				geoLocationSet = true;

			} else {
				window.alert("No results found");
				errorValidation(geoLocationError = true);
			}
		} catch (error) {
			console.warn("Geocoder failed due to: " + error);
			errorValidation(geoLocationError = true);
		}
		errorValidation(geoLocationError);
	}

	
	// CHECK FOR GEOLOCATION THEN USE GOOGLE MAPS GEOCODE TO GET POSTCODE BACK AND SET SELECTED POSTCODE
	async function geoCodePostcode(selectedPostCodeValue) {
		if (!geoLocationSet) {
			if (selectedPostCodeValue != "") {
				geoLocation = "";
				try {
					let response = await geocoder.geocode({ address: selectedPostCodeValue });
					if (response.results[ 0 ]) {
						geoLat = response.results[ 0 ].geometry.location.lat();
						geoLong = response.results[ 0 ].geometry.location.lng();
						geoLocation = { lat: geoLat, lng: geoLong };
						return geoLocation;
					} else {
						window.alert("No results found");
					}
				} catch (error) {
					console.warn("Geocoder failed due to: " + error);
					errorValidation(geoLocationError = true);
					return geoLocationError;
				}
			}
		}
	}



	// SET UP GOOGLE MAP
	const initMap = (geo, zoomLevel = 15, locationKnown = true) => {
		// SET INITIAL MAPS LOCATION, FALLS BACK TO THIS IF ERROR ON LOCATION LOOKUP
		// OPTIONS LIMITS OTHER POINTS OF BUSINESS AND TRAFFIC ETC TO HELP WITH CLARITY ON MAP
		
		if (previousGeoLocation.lat == geo.lat && previousGeoLocation.lng == geo.lng) {
			//console.log("Reusing already fetched map");
		} else {
			latlng = geo;
			let mapOptions = {
				mapId: "b19f8104abf2594f",
				zoom: zoomLevel,
				center: latlng,
				mapTypeId: "roadmap",
				disableDefaultUI: true,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_TOP,
				},
				minZoom: 6,
				
			};
			map = new google.maps.Map(
				document.getElementById("map"), 
				mapOptions
			);

			if (mediaQuery.matches) {
				map.panBy(-300, 0);
			} else { 
				map.panBy(-100, 0);
			}
			

			if (locationKnown) {

				new google.maps.marker.AdvancedMarkerElement({
					position: latlng,
					map,
					title: "Current location",
				});
			}

			setupMapDragListener();

		}

	}

	const setupMapDragListener = () => {
		google.maps.event.addListener(map, "dragend", function () {
			searchHere.classList.remove("ev-map__search-here--hidden");
		});
	}


	// GET GENERALISED PRICE STATISTICS FROM getResultsTATISTICS API
	async function getJSONData(geo) {
		searchHere.classList.add("ev-map__search-here--hidden");
		
		if (!geoLocationError) { 
			loadingOverlay.classList.add("ev-map__loading--open");
		}

		
		if (previousGeoLocation.lat == geo.lat && previousGeoLocation.lng == geo.lng) {
			parseFetchedData(chargePointJsonData, geo);
			//console.log("Reusing already fetched data");
		} else {
			oldArray = chargePointJsonData || [];

			chargePointJsonData = "";
			try {

				let chargePointData = await fetch(`${jsonDataFetchUrl}?latitude=${geo.lat}&longitude=${geo.lng}`);

				const jsonData = await chargePointData.json();
				chargePointJsonData = jsonData;
				chargePointJsonData = chargePointJsonData.concat(oldArray);
				chargePointJsonData = [...new Set(chargePointJsonData) ];

				parseFetchedData(chargePointJsonData, geo);

			} catch (error) {
				console.warn("Error:", error);
				chargerApiError();
			}
		}

		previousGeoLocation = geo;

	}

	const chargerApiError = () => {
		const apiErrorMessage = document.querySelector(".ev-map__api-error-message"); 
		apiErrorMessage.classList.add('ev-map__api-error-message--open');
		loadingOverlay.classList.remove("ev-map__loading--open");
	}

	const parseFetchedData = (chargePointJsonData) => {
		filteredData = [];
		filterConnectionTypes(chargePointJsonData);
		deleteMarkers();
		setchargePointMarkers(filteredData);
	}

	const filterConnectionTypes = (chargePointJsonData) => {
		filteredData = [];
		isChecked = false;
		let showAll = false;
		selectedConnectionType = "";


		if (parseInt(connectionTypes.value) != 0) {
			isChecked = true;
			selectedConnectionType = parseInt(connectionTypes.value);
			filteredData = chargePointJsonData.filter(location =>
				location.Connections.some(charger =>
					charger.ConnectionTypeID === selectedConnectionType
				)
			);
		} else {
 			showAll = true;
		}

		if (!isChecked || showAll) {
			filteredData = chargePointJsonData;
		}
	}
	

	// PLOT MARKERS FOR EACH PETROL STAION ON MAP
	const setchargePointMarkers = (filteredCostData) => {
		
		filteredCostData.forEach(function (point) {

			let myLatlng = { lat: point.AddressInfo.Latitude, lng: point.AddressInfo.Longitude };
			let highestPowerInput = 0;
			
			point.Connections.forEach(function (connection) {
				if (connection.PowerKW > highestPowerInput) {
					highestPowerInput = connection.PowerKW;
				}
			})

			let svgMarker = document.createElement('img');
			svgMarker.style.width = "32px";
			svgMarker.style.height = "32px";
			switch (true) {

				case (highestPowerInput >= 7 && highestPowerInput <= 42):
					svgMarker.src = "https://www.confused.com/static/cmsmedia/cms-widgets/redesign/ev-charging-map/images/Fast.svg";
					break;

				case (highestPowerInput >= 43):
					svgMarker.src = "https://www.confused.com/static/cmsmedia/cms-widgets/redesign/ev-charging-map/images/Rapid.svg";
					break;

				case (highestPowerInput < 7):
					svgMarker.src = "https://www.confused.com/static/cmsmedia/cms-widgets/redesign/ev-charging-map/images/Slow.svg";
					break;

				default:
					svgMarker.src = "https://www.confused.com/static/cmsmedia/cms-widgets/redesign/ev-charging-map/images/Slow.svg";
					break;
			}

			

			let chargePointmarker = new google.maps.marker.AdvancedMarkerElement({
				position: myLatlng,
				map: map,
				content: svgMarker,
				title: `${point.AddressInfo.AddressLine1}`,
				gmpClickable: true,
			});
			markersArray.push(chargePointmarker);


			chargePointmarker.addListener("click", () => {
				
			
				if (desktop.matches) {
					map.setCenter(chargePointmarker.position);
					map.panBy(-200, 0);
				} 

				detailsDrawerOpenToggle();
				connections = "";
				
				point.Connections.forEach(function (connection) {
					let connectionChargeSpeed;
					switch (true) {

						case (connection.PowerKW  >= 7 && connection.PowerKW  <= 42):
							connectionChargeSpeed = "Fast"
							break;
		
						case (connection.PowerKW  >= 43):
							connectionChargeSpeed = "Rapid"
							break;
		
						case (connection.PowerKW  < 7):
							connectionChargeSpeed = "Slow"
							break;
		
						default:
							connectionChargeSpeed = ""
							break;
					}
					
					connections += `
						<tr>
							<td>${connection.ConnectionType.Title && connection.ConnectionType.Title}</td>
							<td>${connection.PowerKW !== null ? connection.PowerKW + "KW" : ""}</td>
							<td>${connectionChargeSpeed !== "" ? connectionChargeSpeed : ""}</td>

						</tr>`;
					
				})

				chargerDetailsContainer.innerHTML = `

					<h3 class="charger-details__heading">${point.AddressInfo.Title}</h3>
					${point.OperatorInfo != null && point.OperatorInfo.Title !== null || point.NumberOfPoints > 0 ? `<p class="charger-details__operator">` : ``}
					${point.OperatorInfo != null && point.OperatorInfo.Title !== null ? `<span class="charger-details__operator--title">` + point.OperatorInfo.Title + ` </span>` : ``}
					${point.NumberOfPoints > 1 ? `<span class="charger-details__operator--number-points"> ` + point.NumberOfPoints + ` charging points</span>` : ``}
					${point.NumberOfPoints === 1 ? `<span class="charger-details__operator--number-points"> ` + point.NumberOfPoints  + ` charging point</span>` : ``}
					${point.OperatorInfo != null && point.OperatorInfo.Title !== null || point.NumberOfPoints > 0 ? `</p>` : ``}
					<address class="charger-details__address">
						${point.AddressInfo.AddressLine1 !== null && point.AddressInfo.AddressLine1 !== point.AddressInfo.Title ? point.AddressInfo.AddressLine1 + `<br/>` : ``}
						${point.AddressInfo.AddressLine2 !== null ? point.AddressInfo.AddressLine2 + `<br/>` : ``}
						${point.AddressInfo.Town !== null ? point.AddressInfo.Town + `<br/>` : ``}
						${point.AddressInfo.Postcode !== null ? point.AddressInfo.Postcode + `<br/>` : ``}
					</address>
					
					<a href="https://www.google.com/maps/dir/?api=1&travelmode=driving&dir_action=navigate&origin=${geoLocation.lat},${geoLocation.lng}&destination=${myLatlng.lat},${myLatlng.lng}" class="charger-details__directions-link" target="_blank" rel="noopener noreferrer nofollow">Get directions</a>

					${connections !== "" ?
						`<h3 class="charger-details__heading">Charging points:</h3>
						<table class="charger-details__charger-list">
							${connections}
						</table>` : ""
					}

					${point.UsageType !== null && point.UsageType.Title !== null ? `<h3 class="charger-details__heading">Usage type:</h3>` : ""}
					${point.UsageType !== null && point.UsageType.Title !== null ? '<p class="charger-details__usage-type">' + point.UsageType.Title + '</p>' : ""}
					${point.UsageCost !== null ? '<p class="charger-details__cost">' + point.UsageCost + '</p>' : ""}

				`;
			});

			loadingOverlay.classList.remove("ev-map__loading--open");
			
			
		});
	};

	// DELETE MARKERS IF NEW LOOKUP IS PERFORMED
	const deleteMarkers = () => {
		if (markersArray) {
			markersArray.forEach(function (marker) {
				marker.setMap(null);
			});
			markersArray.length = 0;
		}
	};

	const detailsDrawerOpenToggle = () => {
		chargerDetailsDrawer.classList.add("ev-map__details-drawer--open");
		mapForm.classList.remove("ev-map__form--open");
		document.querySelector(".ev-map__details-close").setAttribute("tabIndex", 0);

	}
	
	const detailsDrawerCloseToggle = () => {
		chargerDetailsDrawer.classList.remove("ev-map__details-drawer--open");
		mapForm.classList.add("ev-map__form--open");
		document.querySelector(".ev-map__details-close").setAttribute("tabIndex", -1);
	}

	return {
		init: init,
	};
})();

document.addEventListener("DOMContentLoaded", function () {
	cnfsd_evcm.init();
});